export default __webpack_public_path__ + "static/media/img-newsletter-nft-checkout.8a65f347.png";